<style lang="scss" scoped>
.product-img {
    height: 60px;
    width: 60px;
    float: left;
    margin: 5px;
}
.file-upload {
    float: left;
}

.el-form-item {
    margin-bottom:10px;
}
.product-steps-div{
    padding: 0 5px;
}
.product-steps-input {
    width: 110px;
}
</style>

<template>
    <el-dialog
        :title="prdId ? '编辑产品' : '新建产品' "
        width="700px"
        :visible.sync="showDialog"
        @closed="refeshRule"
        top="1vh"
        class="prdocut-dloaig"
    >
        <el-form ref="prdForm" label-width="80px" :model="product" :rules="rules" size="small ">
            <el-form-item label="名称" prop="name">
                <el-input v-model="product.name"></el-input>
            </el-form-item>

            <el-form-item label="销售店铺">
                <el-checkbox-group v-model="tempShops">
                    <el-checkbox :label="item.id" v-for="(item, i) in shops" :key="i">{{item.shortName}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item label="类目" prop="category">
                <el-cascader
                    v-model="product.category"
                    clearable
                    placeholder="选择类型"
                    class="search-item"
                    :options="categorys"
                    :props="props"
                    style="width: 100%"
                    @change="getCode"
                ></el-cascader>
            </el-form-item>

            <el-form-item label="编号" prop="code">
                <el-checkbox v-model="product.autoCode" :disabled="product.id">自动编号</el-checkbox>
                <el-input v-model="product.code" :disabled="product.autoCode" style="width: 69%;margin-left: 5px;"></el-input>
            </el-form-item>

            <el-form-item label="采购链接" prop="link">
                <el-input v-model="product.link"></el-input>
            </el-form-item>

            <el-form-item label="是否精品">
                <el-radio v-model="product.isBoutique" label="Y">是</el-radio>
                <el-radio v-model="product.isBoutique" label="N">否</el-radio>
            </el-form-item>
            
            <el-form-item label="主营范围">
                <el-checkbox-group v-model="tempRegions">
                    <el-checkbox :label="item" v-for="item in $tools.productRegions" :key="item">{{item}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item label="阶梯">
                <el-row>
                    <el-col :span="6" v-for="(item, i) in tempSteps" :key="i" class="product-steps-div">
                        <div >
                            <el-input-number :idx="i" class="product-steps-input" size="mini" @blur="autoStepsBlur($event, i)" v-model="tempSteps[i]" :min="0" :controls="false" :precision="0"></el-input-number>
                            <el-input-number :idx="i" class="product-steps-input" size="mini" @blur="autoStepsBlur($event, i)" v-model="tempStepsNumber[i]" :min="0" :controls="false" :precision="2"></el-input-number>
                        </div>
                    </el-col>
                </el-row>
            </el-form-item>


            <el-form-item label="描述" prop="remark">
                <el-input v-model="product.remark" type="textarea"></el-input>
            </el-form-item>

            <el-form-item label="主图">
                <sn-file-upload
                    relateType="AlibabaProduct"
                    title="上传主图"
                    :imgModel="true"
                    :showList="false"
                    imgSize="260-260"
                    :uploadedCallback="uploadedCallbackMain"
                    :progressCallback="progressCallbackMain"
                >
                    <template>
                        <img class="product-img" v-if="mainImg.base64 || !mainImg.percent" :src="mainImg.base64" />
                        <el-progress class="item-img" type="circle" v-else :percentage="mainImg.percent ? mainImg.percent : 0" :width="60"></el-progress>
                    </template>
                </sn-file-upload>
            </el-form-item>

            <el-form-item label="详情图">
                <sn-file-upload
                    relateType="AlibabaProduct"
                    title="上传主图"
                    :imgModel="true"
                    :showList="false"
                    imgSize="260-260"
                    :uploadedCallback="uploadedCallbackImg1"
                    :progressCallback="progressCallbackImg1"
                >
                    <template>
                        <img class="product-img" v-if="img1.base64 || !img1.percent" :src="img1.base64" />
                        <el-progress class="item-img" type="circle" v-else :percentage="img1.percent ? img1.percent : 0" :width="60"></el-progress>
                    </template>
                </sn-file-upload>

                <sn-file-upload
                    relateType="AlibabaProduct"
                    title="上传主图"
                    :imgModel="true"
                    :showList="false"
                    imgSize="260-260"
                    :uploadedCallback="uploadedCallbackImg2"
                    :progressCallback="progressCallbackImg2"
                >
                    <template>
                        <img class="product-img" v-if="img2.base64 || !img2.percent" :src="img2.base64" />
                        <el-progress class="item-img" type="circle" v-else :percentage="img2.percent ? img2.percent : 0" :width="60"></el-progress>
                    </template>
                </sn-file-upload>

                <sn-file-upload
                    relateType="AlibabaProduct"
                    title="上传主图"
                    :imgModel="true"
                    :showList="false"
                    imgSize="260-260"
                    :uploadedCallback="uploadedCallbackImg3"
                    :progressCallback="progressCallbackImg3"
                >
                    <template>
                        <img class="product-img" v-if="img3.base64 || !img3.percent" :src="img3.base64" />
                        <el-progress class="item-img" type="circle" v-else :percentage="img3.percent ? img3.percent : 0" :width="60"></el-progress>
                    </template>
                </sn-file-upload>
            </el-form-item>

            <el-form-item label="文件包">
                <sn-file-upload
                    relateType="AlibabaProduct"
                    title="上传文件包"
                    :uploadedCallback="uploadedCallbackZip"
                    :deleteCallback="deleteCallback"
                    :files.sync="zip"
                ></sn-file-upload>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button
                v-if="prdId"
                type="primary"
                size="small"
                class="op-button"
                @click="save()"
                title="保存数据，不变更上下架数据"
            >修改</el-button>
            <el-button
                v-if="!prdId"
                type="primary"
                size="small"
                class="op-button"
                @click="save('N')"
                title="保存数据"
            >暂存</el-button>
            <el-button
                type="primary"
                size="small"
                class="op-button"
                @click="save('Y')"
                title="保存数据，商品上架"
            >上架</el-button>
        </div>
    </el-dialog>
</template>

<script>
import SnFileUpload from "../components/SnFileUpload.vue";

export default {
    components: { SnFileUpload },
    props: {
        prdId: { type: Number, default: 0 },
        show: { type: Boolean, default: false },
        added: { type: Function, default: null },
        isRelease: { type: Boolean, default: false },
    },
    data() {
        return {
            showDialog: false,
            product: {
                code: null,
                autoCode: true
            },
            mainImg: {},
            img1: {},
            img2: {},
            img3: {},
            zip: [],
            categorys: null,
            shops: null,
            tempShops: [],
            tempRegions:[],
            tempSteps:[0],
            tempStepsNumber:[0],
            props: {
                value: "id",
                label: "name",
                expandTrigger: "hover",
                emitPath: false,
            },
            rules: {
                name: [
                    { required: true, message: "请输入名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 128,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],

                category: [
                    { required: true, message: "请选择类目", trigger: "blur" },
                ],
                code: [
                    { required: true, message: "请输入编码", trigger: "blur" },
                    {
                        min: 1,
                        max: 64,
                        message: "长度在 1 到 64 个字符",
                        trigger: "blur",
                    },
                ],

                link: [
                    { message: "请输采购链接", trigger: "blur" },
                    {
                        min: 1,
                        max: 2048,
                        message: "长度在 1 到 2048 个字符",
                        trigger: "blur",
                    },
                ],
                remark: [
                    { message: "请输入描述", trigger: "blur" },
                    {
                        min: 1,
                        max: 1024,
                        message: "长度在 1 到 1024 个字符",
                        trigger: "blur",
                    },
                ],
            },
            regions:["美国", "英国", "法国", "德国", "加拿大", "南非", "新加坡", "印度", "澳洲", "东盟", "拉美", "东南亚", "非洲"]
        };
    },
    methods: {
        getShops() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/valid"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        getCategory() {
            let _this = this;

            _this.$http.post(
                ["alibaba/product/category/tree"],
                [
                    function (data) {
                        _this.categorys = data;
                    },
                ],
                ".product-main"
            );
        },
        uploadedCallbackMain(files, file) {
            this.mainImg = {
                base64: file.base64,
                name: file.name,
                size: file.size,
                address: file.address,
                id: file.id,
                creator: file.creator,
                contentType: file.contentType,
            };
        },
        progressCallbackMain(evel) {
            this.mainImg = {percent: window.parseInt(evel.percent)}
        },
        uploadedCallbackImg1(files, file) {
            this.img1 = {
                base64: file.base64,
                name: file.name,
                size: file.size,
                address: file.address,
                id: file.id,
                creator: file.creator,
                contentType: file.contentType,
            };
        },
        progressCallbackImg1(evel) {
            this.img1 = {percent: window.parseInt(evel.percent)}
        },
        uploadedCallbackImg2(files, file) {
            this.img2 = {
                base64: file.base64,
                name: file.name,
                size: file.size,
                address: file.address,
                id: file.id,
                creator: file.creator,
                contentType: file.contentType,
            };
        },
        progressCallbackImg2(evel) {
            this.img2 = {percent: window.parseInt(evel.percent)}
        },
        uploadedCallbackImg3(files, file) {
            this.img3 = {
                base64: file.base64,
                name: file.name,
                size: file.size,
                address: file.address,
                id: file.id,
                creator: file.creator,
                contentType: file.contentType,
            };
        },
        progressCallbackImg3(evel) {
            this.img3 = {percent: window.parseInt(evel.percent)}
        },
        uploadedCallbackZip(files, file) {
            this.zip = [
                {
                    name: file.name,
                    size: file.size,
                    address: file.address,
                    id: file.id,
                    creator: file.creator,
                    contentType: file.contentType,
                    isNew: "Y",
                },
            ];
        },
        deleteCallback(id, msg) {
            let _this = this;

            _this.$http.post(
                [_this.isRelease ? "alibaba/product/saveMyrelease" : "alibaba/product/save", { id: _this.product.id, zip: -1 }],
                [
                    function (data) {
                        msg("文件删除成功");
                    },
                ],
                ".prdocut-dloaig"
            );
        },
        refeshRule() {
            this.product = {code: null, autoCode: true};
            this.mainImg = {};
            this.img1 = {};
            this.img2 = {};
            this.img3 = {};
            this.zip = [];
            this.$refs["prdForm"].resetFields();
            this.$emit("update:prdId", false);
            this.$emit("update:show", false);
        },
        save(status) {
            let _this = this;
            _this.$refs["prdForm"].validate().then(function () {
                _this.product.status = status;
                _this.dosave();
            });
        },
        dosave() {
            let _this = this;

            let saveData = {
                id: _this.product.id,
                name: _this.product.name,
                code: _this.product.code,
                remark: _this.product.remark,
                category: _this.product.category,
                status: _this.product.status ? _this.product.status : null,
                link: _this.product.link,
                autoCode: _this.product.autoCode ? 'Y' : 'N',
                shops: _this.tempShops.join(","),
                region: _this.tempRegions.join(","),
                steps: _this.getSteps(),
                isBoutique: _this.product.isBoutique
            };

            if (_this.mainImg && _this.mainImg.id) {
                saveData.mainImgBase = _this.mainImg.base64;
                saveData.mainImgFile = _this.mainImg;
            }

            if (_this.img1 && _this.img1.id) {
                saveData.imgOneFile = _this.img1;
                saveData.imgOneBase = _this.img1.base64;
            }

            if (_this.mainImg && _this.img2.id) {
                saveData.imgTwoFile = _this.img2;
                saveData.imgTwoBase = _this.img2.base64;
            }

            if (_this.mainImg && _this.img3.id) {
                saveData.imgThreeFile = _this.img3;
                saveData.imgThreeBase = _this.img3.base64;
            }

            if (_this.zip && _this.zip[0] && "Y" == _this.zip[0].isNew) {
                saveData.zipFile = _this.zip[0];
            }

            _this.$http.post(
                [_this.isRelease ? "alibaba/product/saveMyrelease" : "alibaba/product/save", saveData],
                [
                    function (data) {
                        _this.showDialog = false;

                        if (_this.added) {
                            _this.added();
                        }
                    },
                ],
                ".prdocut-dloaig"
            );
        },
        getPrd() {
            let _this = this;

            _this.$http.post(
                [_this.isRelease ? "/alibaba/product/getMyrelease" : "alibaba/product/get", { id: _this.prdId }],
                [
                    function (data) {
                        _this.product = data;
                        _this.showDialog = true;

                        _this.tempShops = _this.$tools.splitToInt(data.shops, ",");

                        _this.tempRegions = data.region != null ? data.region.split(",").filter(function(el) { return el;}) : [];
                        _this.tempSteps = [];
                        _this.tempStepsNumber = [];

                        if (data.steps) {
                            let tempSteps = eval(data.steps)
                            
                            for (var i in tempSteps) {
                                _this.tempSteps[i] = tempSteps[i][0];
                                _this.tempStepsNumber[i] = tempSteps[i][1];
                            }
                        }

                        window.setTimeout(function() {
                             _this.setFile(data);
                        }, 100);
                       
                    },
                ],
                ".prdocut-dloaig"
            );
        },
        setFile(data) {
            if (data.mainImgBase) {
                this.mainImg = {
                    base64: data.mainImgBase,
                    mainImg: data.mainImg,
                };
            } else {
                this.mainImg = {};
            }

            if (data.imgOneBase) {
                this.img1 = {
                    base64: data.imgOneBase,
                    mainImg: data.imgOne,
                };
            }

            if (data.imgTwoBase) {
                this.img2 = {
                    base64: data.imgTwoBase,
                    mainImg: data.imgTwo,
                };
            }

            if (data.imgThreeBase) {
                this.img3 = {
                    base64: data.imgThreeBase,
                    mainImg: data.imgThree,
                };
            }

            if (data.zipFile) {
                this.zip = [data.zipFile];
            }
        },
        getCode() {
            let _this = this;

            _this.$http.post(
                ["alibaba/product/category/getCode", { id: _this.product.category }],
                [
                    function (data) {
                        _this.product.code = data;
                    },
                ],
                ".prdocut-dloaig"
            );
        },
        autoStepsBlur(event, idx) {
            let _this = this;

            window.setTimeout(function() {
                if (idx < 3 && (_this.tempSteps[idx] != 0 || _this.tempStepsNumber[idx] != 0)) { //  自动增加下级阶梯
                    _this.tempSteps[idx + 1] = 0;
                    _this.tempStepsNumber[idx + 1] = 0;
                }

                if (idx > 0 && idx < 3 && (!_this.tempSteps[idx] && !_this.tempStepsNumber[idx]) && (!_this.tempSteps[idx + 1] && !_this.tempStepsNumber[idx + 1])) { // 自动删减阶梯
                    _this.tempSteps.splice(idx + 1);
                    _this.tempStepsNumber.splice(idx + 1);
                }
            }, 300);
        },
        getSteps() {
            let _this = this;
            let data = [];

            for (var i in _this.tempSteps) {
                if (_this.tempSteps[i] && _this.tempStepsNumber[i]) {
                    data.push([_this.tempSteps[i], _this.tempStepsNumber[i]]);
                }
            }

            return data;
        },
        flushData() {
            this.tempShops = [];
            this.tempRegions = [];
            this.tempSteps = [];
            this.tempStepsNumber = [];
        }
    },
    mounted() {},
    watch: {
        show(val) {
            if (val) {
                this.getCategory();
                this.getShops();

                if (this.prdId) {
                    this.getPrd();
                } else {
                    this.flushData();
                    this.showDialog = val;
                }
            } else {
                this.showDialog = val;
            }
        },
    },
};
</script>